import React from 'react';

/** 普通上报：青绿；重要上报：警红 */
const THEMES = {
  normal: {
    background: '#e8f7f2',
    border: '1px solid #7bc9b0',
    borderLeft: '3px solid #2a9d8f',
    accent: '#1f6f64',
    text: '#102a27',
    icon: '#2a9d8f',
    link: '#0b6e99',
    closeHover: '#c8ebe1',
    shadow: '0 2px 8px rgba(42, 157, 143, 0.16)',
    label: '队员上报'
  },
  important: {
    background: '#fff1f0',
    border: '1px solid #ffa39e',
    borderLeft: '3px solid #cf1322',
    accent: '#a8071a',
    text: '#1a0505',
    icon: '#cf1322',
    link: '#0958d9',
    closeHover: '#ffccc7',
    shadow: '0 2px 8px rgba(207, 19, 34, 0.18)',
    label: '重要上报'
  }
};

/**
 * 地图正上方：精小前线消息卡片
 */
export default function DashboardFieldMessageBanner({
  visible,
  message,
  onClose,
  onFlyTo
}) {
  if (!visible || !message) return null;

  const important = !!message.important;
  const theme = important ? THEMES.important : THEMES.normal;
  const lng = Number(message.longitude);
  const lat = Number(message.latitude);
  const hasCoord = Number.isFinite(lng) && Number.isFinite(lat);
  const coordText = hasCoord
    ? `${lng.toFixed(5)}, ${lat.toFixed(5)}`
    : '暂无坐标';

  return (
    <div
      style={{
        background: theme.background,
        border: theme.border,
        borderLeft: theme.borderLeft,
        borderRadius: 6,
        padding: '5px 8px 5px 8px',
        width: '100%',
        minWidth: 220,
        maxWidth: 'min(320px, 100%)',
        boxShadow: theme.shadow,
        animation: 'zhxtMapTopSlideDown 0.28s ease-out',
        pointerEvents: 'auto',
        flexShrink: 0
      }}
      role="status"
      aria-live="polite"
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 6 }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
            <span style={{ marginRight: 4, fontSize: 11, color: theme.icon, lineHeight: 1 }} aria-hidden>
              {important ? '🚨' : '💬'}
            </span>
            <span style={{
              fontSize: 11,
              fontWeight: 600,
              color: theme.accent,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
            >
              {theme.label}
              {message.name ? ` · ${message.name}` : ''}
            </span>
          </div>
          <div style={{
            fontSize: 13,
            fontWeight: 700,
            color: theme.text,
            lineHeight: 1.35,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            marginBottom: 2
          }}
          >
            {message.text}
          </div>
          <div style={{
            fontSize: 10,
            color: theme.accent,
            opacity: 0.9,
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 6,
            lineHeight: 1.3
          }}
          >
            <span>
              位置：
              {hasCoord ? (
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    onFlyTo?.(message);
                  }}
                  style={{
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    margin: 0,
                    color: theme.link,
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    fontSize: 10,
                    fontWeight: 600
                  }}
                  title="点击飞行到队员位置"
                >
                  {coordText}
                </button>
              ) : (
                <span style={{ opacity: 0.75 }}>{coordText}</span>
              )}
            </span>
            {!important && (
              <span style={{ opacity: 0.65 }}>15s 关闭</span>
            )}
          </div>
        </div>
        <button
          type="button"
          onClick={onClose}
          style={{
            background: 'none',
            border: 'none',
            color: theme.accent,
            fontSize: 13,
            cursor: 'pointer',
            padding: '0 2px',
            borderRadius: 3,
            lineHeight: 1,
            flexShrink: 0
          }}
          onMouseEnter={(e) => { e.currentTarget.style.background = theme.closeHover; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = 'none'; }}
          title="关闭"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
